var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.dialogTitle,
        size: "lg",
        "confirm-loading": _vm.loading,
        "confirm-text": "Lưu",
        "cancel-text": "Đóng",
        "use-panel": true,
        "panel-title": "Nhận xét định kỳ",
        "panel-subtitle": _vm.panelSubtitle,
        "panel-icon": "el-icon-s-claim",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        confirm: _vm.handleSave,
        cancel: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "sk-u-mt-12",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.formRules,
            "label-position": "top",
          },
        },
        [
          _c(
            "div",
            { staticClass: "pev-form-header" },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "pev-form-item",
                  attrs: { label: "Lần đánh giá", prop: "periodNumber" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "140px" },
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.dataForm.periodNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "periodNumber", $$v)
                      },
                      expression: "dataForm.periodNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "pev-form-item",
                  attrs: { label: "Ngày", prop: "date" },
                },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "180px" },
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      format: "dd/MM/yyyy",
                      placeholder: "Chọn ngày",
                      clearable: false,
                    },
                    model: {
                      value: _vm.dataForm.date,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "date", $$v)
                      },
                      expression: "dataForm.date",
                    },
                  }),
                ],
                1
              ),
              !_vm.isEditMode
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "pev-form-item",
                      attrs: { label: "Chế độ duyệt" },
                    },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "Tự duyệt",
                          "inactive-text": "Chờ duyệt",
                        },
                        model: {
                          value: _vm.dataForm.approved,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "approved", $$v)
                          },
                          expression: "dataForm.approved",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          !_vm.isEditMode
            ? _c("div", { staticClass: "pev-form-students" }, [
                _c(
                  "div",
                  { staticClass: "pev-form-students__header" },
                  [
                    _c(
                      "p",
                      { staticClass: "pev-form-students__title" },
                      [
                        _vm._v("\n          Nhận xét cho học sinh\n          "),
                        _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "info" } },
                          [
                            _vm._v(
                              _vm._s(_vm.validStudentCount) +
                                "/" +
                                _vm._s(_vm.dataForm.students.length) +
                                " đã nhập"
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "pev-form-checkbox",
                        model: {
                          value: _vm.showOnlyEmpty,
                          callback: function ($$v) {
                            _vm.showOnlyEmpty = $$v
                          },
                          expression: "showOnlyEmpty",
                        },
                      },
                      [_vm._v("\n          Chỉ hiện HS chưa nhập\n        ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pev-form-students__list" },
                  _vm._l(_vm.filteredStudents, function (student) {
                    return _c(
                      "div",
                      {
                        key: student.studentId,
                        staticClass: "pev-student-row",
                      },
                      [
                        _c("div", { staticClass: "pev-student-row__info" }, [
                          _c(
                            "span",
                            { staticClass: "pev-student-row__index" },
                            [
                              _vm._v(
                                _vm._s(_vm.getOriginalIndex(student) + 1) + "."
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "pev-student-row__name" }, [
                            _vm._v(_vm._s(student.studentName)),
                          ]),
                        ]),
                        _c("el-input", {
                          staticClass: "pev-student-row__input",
                          attrs: {
                            type: "textarea",
                            rows: 2,
                            placeholder: `Nhập nhận xét cho ${student.studentName}...`,
                            maxlength: "2000",
                            "show-word-limit": "",
                          },
                          model: {
                            value: student.content,
                            callback: function ($$v) {
                              _vm.$set(student, "content", $$v)
                            },
                            expression: "student.content",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ])
            : _c(
                "div",
                { staticClass: "pev-form-edit" },
                [
                  _c("div", { staticClass: "pev-form-edit__student" }, [
                    _c("i", { staticClass: "el-icon-user" }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.dataForm.students[0] &&
                            _vm.dataForm.students[0].studentName
                        )
                      ),
                    ]),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Nội dung nhận xét",
                        prop: "editContent",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 6,
                          placeholder: "Nhập nội dung nhận xét...",
                          maxlength: "2000",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.dataForm.editContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "editContent", $$v)
                          },
                          expression: "dataForm.editContent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
          _c(
            "div",
            { staticClass: "evl-upload-section" },
            [
              _c("div", { staticClass: "evl-upload-section__header" }, [
                _c("span", { staticClass: "evl-upload-title" }, [
                  _c("i", { staticClass: "el-icon-paperclip" }),
                  _vm._v(" File & hình ảnh đính kèm\n        "),
                ]),
                _c("span", { staticClass: "evl-upload-subtitle" }, [
                  _vm._v(
                    "Tối đa 3 file/nhận xét (dùng chung cho các học sinh đã chọn)"
                  ),
                ]),
              ]),
              _c(
                "el-upload",
                {
                  staticClass: "evl-drag-uploader",
                  attrs: {
                    drag: "",
                    action: "#",
                    "auto-upload": false,
                    "file-list": _vm.fileList,
                    limit: 3,
                    accept: "image/*,.pdf,.doc,.docx,.xls,.xlsx",
                    multiple: "",
                    "on-change": _vm.handleFileChange,
                    "on-remove": _vm.handleFileRemove,
                    "on-exceed": _vm.handleFileExceed,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("\n          Kéo thả file/ảnh vào đây hoặc "),
                    _c("em", [_vm._v("nhấn để chọn file")]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }